import React from 'react';
import PropTypes from 'prop-types';

const LeftNavChild = ({ nav, index, setSupportNav, activeParentNav }) => {
  const { name, children, activeChild } = nav;
  let childNav = null;
  if (children.length > 0 && activeParentNav[name]) {
    const childNavItems = children.map((child, j) => {
      let childListClassName = 'mri-support-navigation--list-item';
      let childListLinkClassName = 'mri-support-navigation--link';
      if (activeChild === child) {
        childListClassName += '  mri-support-navigation--active';
        childListLinkClassName += ' mri-support-navigation--link--active';
      }
      return (
        <li id={`${index}_${name}_${j}_${child}`} key={`${index}_${name}_${j}_${child}`} className={childListClassName}>
          <button className={childListLinkClassName} onClick={() => setSupportNav(name, child)} type="button">{child}</button>
        </li>
      );
    });

    childNav = (
      <div className="mri-support-sub-nav">
        <ul className="mri-support-navigation--list">
          {childNavItems}
        </ul>
      </div>
    );
  }
  return childNav;
};

LeftNavChild.propTypes = {
  nav: PropTypes.instanceOf(Object),
  index: PropTypes.number,
  setSupportNav: PropTypes.func,
  activeParentNav: PropTypes.instanceOf(Object),
};

export default LeftNavChild;
